import React from 'react';

export function QuickActionCard({ icon: Icon, title, description, color, onClick }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-4 p-4 bg-white border border-[#E2E8F0] rounded-lg hover:shadow-md transition-all text-left w-full"
    >
      <div className={`${color} p-3 rounded-lg flex-shrink-0`}>
        <Icon size={24} className="text-white" />
      </div>
      <div>
        <h4 className="font-semibold text-[#2C3E50]">{title}</h4>
        <p className="text-sm text-[#7F8C8D]">{description}</p>
      </div>
    </button>
  );
}

export default QuickActionCard;
